// extracted by mini-css-extract-plugin
export default {"fail_d":"Failed_fail_d__waV05","fail":"Failed_fail__PrEL1","fail_l":"Failed_fail_l__KPxVv"};